import apiDefaults from '@/api/defaultConfiguration';
import { DamagecasesApiFactory } from '@/api/generated';
import { getUnixTimestamp } from '@/plugins/Utils';

export default {
	state: {
		repairExtension: null,
		needUpdate: false,
	},
	getters: {
		getRepairExtensionNeedUpdate(state) {
			return state.needUpdate;
		},
		getRepairExtension(state) {
			return state.repairExtension;
		},
	},
	mutations: {
		clearRepairExtension(state) {
			state.repairExtension = null;
		},
		setRepairExtension(state, payload) {
			state.repairExtension = payload;
			if (state.repairExtension) {
				state.repairExtension._ttl = getUnixTimestamp() + 60;
			}
		},
		setRepairExtensionNeedUpdate(state, payload) {
			state.needUpdate = payload;
		},
	},
	actions: {
		updateRepairExtension({ commit, dispatch, getters }, payload) {
			const id = payload?.id || getters.getRepairExtension?.id;
			const isDamageCaseSet = getters.getDamageCase?.id !== undefined;
			const isRepairExtensionSet = getters.getRepairExtension?.length;
			const isDifferentId = isDamageCaseSet && payload.id && payload?.id?.toString() !== getters.getDamageCase?.id.toString();
			const isRepairExtensionOutdated = isRepairExtensionSet && getters.getRepairExtension?._ttl < getUnixTimestamp();
			const forceUpdateRepairExtensions = getters.getRepairExtensionNeedUpdate;

			if ((id && (!isRepairExtensionSet || isDifferentId || isRepairExtensionOutdated)) || forceUpdateRepairExtensions) {
				return DamagecasesApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios)
					.damagecasesIdRepairextensionsGet(id)
					.then(response => {
						if (response.data) {
							commit('setRepairExtension', response.data);
							commit('setRepairExtensionNeedUpdate', false);
						}
					})
					.catch(() => {
						commit('setRepairExtension', null);
					});
			}
		},
	},
};
